import React, { useState, useEffect, useRef } from "react";
import { Scrollama, Step } from "react-scrollama";
import Header from "./Header";
import Footer from "./Footer";
import TimelineMinimap from "./Minimap";
import Day from "./Day";

import copy from "../copy.json";

const useIntersection = (ref, selector, handler, options) => {
  useEffect(() => {
    const observers = [];

    if (ref.current && typeof IntersectionObserver === "function") {
      const handleIntersect = (idx) => (entries) => {
        handler(entries[0], idx);
      };

      ref.current.querySelectorAll(selector).forEach((node, idx) => {
        const observer = new IntersectionObserver(
          handleIntersect(idx),
          options
        );
        observer.observe(node);
        observers.push(observer);
      });

      return () => {
        observers.forEach((observer) => {
          observer.disconnect();
        });
      };
    }
    return () => {};
  }, [ref.current, options.threshold, options.rootMargin]);
};

const Main = () => {
  const [scene, setScene] = useState(0);
  const ref = useRef(null);

  // This worked after react-scrollama did not, so thank you Varun!
  // https://varun.ca/scrollytelling/
  useIntersection(
    ref,
    ".page",
    (entry, idx) => {
      // console.log(entry);
      if (entry.isIntersecting) {
        // console.log(idx)
        setScene(idx);
      }
    },
    { threshold: 0.5 }
  );

  // useEffect(() => {
  //   ref.current.querySelector(`.page:nth-child(${scene + 1})`).scrollIntoView();
  // });

  const setDay = (idx) => {
    // setScene(idx);
  };

  const timeline = copy.timeline.map((d) => ({ ...d, date: new Date(d.date) }));
  // console.log(timeline);
  return (
    <div className="scroll-wrapper">
      <div className="story-wrapper">
        <TimelineMinimap
          timeline={timeline}
          current={scene}
          handleClick={setDay}
        />
        <div ref={ref}>
          <Header />
          {timeline.map(({ title, date, desc, img }) => (
            <Day title={title} date={date} desc={desc} img={img} key={date} />
          ))}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Main;
